"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import StaffCarManagementList from "./StaffCarManagementList"
import StaffModal from "./StaffModal"
import CarModal from "./CarModal"
import type { Staff, Car, TokenData } from "./types"

interface StaffCarManagementContainerProps {
  token: string
  tokenData: TokenData
}

const StaffCarManagementContainer: React.FC<StaffCarManagementContainerProps> = ({ token, tokenData }) => {
  const [staffModalOpen, setStaffModalOpen] = useState(false)
  const [selectedStaff, setSelectedStaff] = useState<Staff | null>(null)
  const [carModalOpen, setCarModalOpen] = useState(false)
  const [selectedCar, setSelectedCar] = useState<Car | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  // Staff Handlers
  const handleOpenAddStaff = () => {
    setSelectedStaff(null)
    setStaffModalOpen(true)
  }

  const handleOpenEditStaff = (item: Staff) => {
    setSelectedStaff(item)
    setStaffModalOpen(true)
  }

  const handleStaffSuccess = () => {
    setStaffModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  // Car Handlers
  const handleOpenAddCar = () => {
    setSelectedCar(null)
    setCarModalOpen(true)
  }

  const handleOpenEditCar = (item: Car) => {
    setSelectedCar(item)
    setCarModalOpen(true)
  }

  const handleCarSuccess = () => {
    setCarModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <StaffCarManagementList
              token={token}
              tokenData={tokenData}
              onAddStaff={handleOpenAddStaff}
              onEditStaff={handleOpenEditStaff}
              onAddCar={handleOpenAddCar}
              onEditCar={handleOpenEditCar}
              refreshTrigger={refreshTrigger}
            />
          </Col>
        </Row>

        {/* Staff Modal */}
        <StaffModal
          isOpen={staffModalOpen}
          toggle={() => setStaffModalOpen(false)}
          onSuccess={handleStaffSuccess}
          initialData={selectedStaff}
          token={token}
          tokenData={tokenData}
        />

        {/* Car Modal */}
        <CarModal
          isOpen={carModalOpen}
          toggle={() => setCarModalOpen(false)}
          onSuccess={handleCarSuccess}
          initialData={selectedCar}
          token={token}
          tokenData={tokenData}
        />
      </Container>
    </>
  )
}

export default StaffCarManagementContainer
